export const environment = {
  apiUrl:
    'https://gpz53idetl3gwvusa3h3ey2rxy0nbtwl.lambda-url.ap-southeast-1.on.aws/api/v1',
  socketIoUrl: 'wss://socket-io-aimi.alitechhouse.com',
  socketAuth:
    'cmVhZDo2RGZDU0N6QlNwTVV0Ymg5SnoxVzBzWUVabFVwbDNPdDNFc0ZJY2RGY1dvWEFLd3g4RA==',
  googleCloud: {
    firebaseAuth: {
      apiKey: 'AIzaSyDOLSZ-bEW-aRNXrctb6zc-3g2W93fRWDU',
      authDomain: 'aimi-prod.firebaseapp.com',
      projectId: 'aimi-prod',
      storageBucket: 'aimi-prod.firebasestorage.app',
      messagingSenderId: '219005221431',
      appId: '1:219005221431:web:86afb45be84ff7934c1db2',
    },
  },
};
